export const enum topup {
  commission = 3,
  min = 5,
  max = 1000000000,
}

export const enum withdrawal {
  commission = 3,
  min = 50000,
  max = 1000000000,
}

export enum paymentTypes {
  payme = "payme",
  click = "click",
  didox = "didox",
}
